import { PROPOSAL_PENDING } from 'components/proposal_types';
import { useSelector } from 'react-redux';
import { GenericObject, ProposalEntity } from 'v2/models';
import { filterApprovedProposals, getKeyCount } from 'v2/utils/proposalUtils';

export default function useSelectUnreadProposals() {
  const selectUnreadProposals = useSelector((state: GenericObject) => {
    const checkFunction = (proposal: ProposalEntity): boolean =>
      !proposal.data_buyer_response ||
      proposal.data_buyer_response.action === PROPOSAL_PENDING;
    const approvedProposals = filterApprovedProposals(
      state.proposals.multipleProposals
    );
    return getKeyCount(approvedProposals, checkFunction);
  });

  return selectUnreadProposals;
}
